import { createReducer } from '@reduxjs/toolkit';
import { SET_DATA_ARTISTS, SET_DATA_ARTISTS_SLIDER } from '../actions/ArtistsActions';

const initialState = {
    dataArtists: [],
    dataArtistsSlider: [],
};

const artists = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_DATA_ARTISTS, (state, action) => {
            state.dataArtists = action.data;
        })
        .addCase(SET_DATA_ARTISTS_SLIDER, (state, action) => {
            state.dataArtistsSlider = action.dataArtistsSlider;
        });
});

export default artists;
